<template>
  <div class="login-another">
    <p class="t"><span>第三方登录</span></p>
    <p class="l-icon">
      <i class="iconfont iconweixin" style="font-size:38px" @click="wechatHandleClick('wechat')" />
      <i class="iconfont iconqq1" @click="tencentHandleClick('tencent')" />
    </p>
    <div class="wxQrCode" v-show="isShowWx">
      <div class="close" @click="isShowWx = false"></div>
      <div id="login_container"></div>
    </div> 
  </div>
</template>

<script>

export default {
  data() {
    return {
      isShowWx: false
    }
  },
  methods: {
    wechatHandleClick() {
        //正式环境   wxed8115892a85ea55
        //测试环境  wx400c74ddf899af13
      this.isShowWx = true
      const appid = process.env.MODE == 'pro' ? 'wx14b9ed1bdad56d7c' : 'wx25ba5802e83c27de'
      const redirect_uri =
        process.env.MODE == 'pro'
          ? encodeURIComponent('https://twinsearth.laozicloud.com')
          : encodeURIComponent('https://twinsearth.laozicloud.net')

      // const url = `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_login&state=wechat#wechat_redirect`
      // window.location.href = url
      var obj = new WxLogin({
        self_redirect: false,
        id: 'login_container',
        appid: appid,
        scope: 'snsapi_login',
        redirect_uri: redirect_uri,
        state: '',
        style: '',
        href: ''
      })
    },
    tencentHandleClick() {
      const client_id = '101468365'
      const redirect_uri =
        process.env.MODE == 'pro'
          ? encodeURIComponent('https://twinsearth.laozicloud.com')
          : encodeURIComponent('https://twinsearth.laozicloud.net')
      const url = `https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=${client_id}&redirect_uri=${redirect_uri}&state=tencent`
      window.location.href = url
    }
  }
}
</script>  

<style lang="scss" scoped>

.login-another {
  width:320px;
  .t {
    color: #C0C3C8;
    text-align: center;
    font-size: 14px;
    margin-top: 47px;
    position: relative;
    span{
        display: inline-block;
        position: relative;
        background:#ffffff;
        z-index: 99;
        padding: 0px 15px;
    }
    &::before{
         content: '';
    background-color: #F7F9FC;
    width: 100%;
    height: 1px;
    position: absolute;
    top: 10px;
    left: 0;
    }
  }
  .l-icon {
    margin-top: 30px;
    padding: 0 30px;
    justify-content: space-around;
    display: flex;
    align-items: center;
    position: relative;
    i{
        &:first-child{
            background:  #17C444;
        } 
         &:first-child + i {
             background: #1191FF;
         }

    }
    .iconfont {
      cursor: pointer;
      width: 64px;
      height: 64px;
      display: inline-block;
      line-height: 64px;
      text-align: center;
      color: #fff;
      border-radius: 50%;
      font-size: 28px;
      z-index: 2;
    //   &:first-child {
    //     background: #17C444 url('../assets/images/weixin.png') no-repeat center
    //       center;
    //     background-size: 33px 33px;
    //   }
    //   &:first-child + i {
    //     background: #1191FF url('../assets/images/qq.png') no-repeat center center;
    //     background-size: 22px 22px;
    //   }
    }
    .icon-qq {
      font-size: 21px;
    }
  }
//   .l-icon::before {
//     content: '';
//     background-color: #e4e9f3;
//     width: 100%;
//     height: 1px;
//     position: absolute;
//   }
  .wxQrCode{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: #fff;
    #login_container{
      padding: 50px 50px 0;
      margin-left: 15px;
    }
    .close{
      position: absolute;
      top: 0;
      left: 0;
      width: 50px;
      height: 50px;
      background: #f2eff7 url("../assets/images/left.png") no-repeat 10px 10px;
      background-size: 20px;
      border-bottom-right-radius: 100%;
      cursor: pointer;
    }
  }
}
</style>